import * as React from "react";
import { ITicket } from "@nkr/models/index";
import { TicketStatus } from "@nkr/enums/index";
import { Modal, Button, Table } from "react-bootstrap";
import styled from "styled-components";

const TableWrapper = styled(Table)`
    // width: 90%;
    // margin-left: auto;
    // margin-right: auto;

    & > thead > tr > th {
        background-color: #133366;
        color: #FFF;
        text-align: center;
        // padding-right: 10px;
        // width: 22%;
    }

    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IProps {
    show: boolean,
    action: TicketStatus,
    data: ITicket,
    isCenter: boolean,
    onCloseReopen: (ticketId: number) => void,
    onCancel: () => void
}

class TicketCloseReopen extends React.Component<IProps, {}> {
    handleCloseReopen = () => {
        this.props.onCloseReopen(this.props.data.id);
    }

    handleCancel = () => {
        this.props.onCancel();
    }

    private getAction = () => {
        switch (this.props.action) {
            case TicketStatus.Closed:
                return { verb: "close", button: "Close" };
            case TicketStatus.Reopened:
                return { verb: "reopen", button: "Reopen" };
        }
    }

    render = () => {
        if (this.props.data == null)
            return null;

        const action = this.getAction();
        const assignedUser = this.props.data.assignedUser ? `${this.props.data.assignedUser.firstName} ${this.props.data.assignedUser.lastName}` : '[Pending Assignment]';

        return (
            <>
                <Modal bsSize="large" show={this.props.show} onHide={this.handleCancel}>
                    <Modal.Header className="h4">
                        {action.button} Ticket
                    </Modal.Header>

                    <Modal.Body>
                        <p>Please confirm that you would like to {action.verb} the following ticket:</p>

                        <TableWrapper bordered condensed>
                            <thead>
                                <tr>
                                    <th>Ticket #</th>

                                    <th>From</th>

                                    {!this.props.isCenter && (
                                        <th>Origin</th>
                                    )}

                                    {this.props.data.dashRegistration != null && (
                                        <th>Center</th>
                                    )}

                                    <th>Type</th>

                                    {!this.props.isCenter && (
                                        <th>Tier</th>
                                    )}

                                    <th>Assigned User</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{this.props.data.id}</td>

                                    <td>
                                        {this.props.data.contact.fullName}<br />
                                        {this.props.data.contact.email}
                                    </td>

                                    {!this.props.isCenter && (
                                        <td>{this.props.data.entityTypeName}</td>
                                    )}

                                    {this.props.data.dashRegistration != null && (
                                        <td>{this.props.data.dashRegistration != null ? this.props.data.dashRegistration.center.centerAlias : ""}</td>
                                    )}

                                    <td>{this.props.data.ticketTypeName}</td>
                                    {!this.props.isCenter && (
                                        <td>{this.props.data.tierLevelName}</td>
                                    )}

                                    <td>{assignedUser}</td>
                                </tr>
                            </tbody>
                        </TableWrapper>
                    </Modal.Body>

                    <Modal.Footer>
                        <Button bsStyle="primary" onClick={this.handleCloseReopen}>{action.button}</Button>
                        <Button onClick={this.handleCancel}>Cancel</Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default TicketCloseReopen;